'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import I18n from 'I18n';
import { getFolderSubcategoryI18nKey, getFolderDefaultI18nKey, translateFolderPath } from 'DesignData/helpers/finderHelpers';
import ImmutableModel from 'DesignData/models/ImmutableModel';
import { DESIGN_ROOT } from 'DesignData/enums/FolderSubcategories';
import { FOLDER } from 'DesignData/constants/FolderAssetTypes';
export default class Folder extends ImmutableModel {
  constructor(props) {
    const {
      name: __name
    } = props,
          rest = _objectWithoutPropertiesLoose(props, ["name"]);

    const {
      fullPath: __folderPath,
      generated,
      subcategory
    } = rest;
    let folderName;

    if (generated && subcategory && subcategory !== DESIGN_ROOT) {
      folderName = I18n.text(getFolderSubcategoryI18nKey(subcategory), {
        defaultValue: I18n.text(getFolderDefaultI18nKey())
      });
    } else {
      folderName = __name;
    }

    const folderPath = translateFolderPath(__folderPath);
    return super(rest).set('type', FOLDER).set('__name', folderName).set('__folderPath', folderPath);
  }

  get name() {
    return this.__name;
  }

  set name(name) {
    this.__name = name;
  }

  get folderPath() {
    return this.__folderPath;
  }

}